import type { CustomUseQueryOptions } from '../types';
import { hasNonEmptyProp } from '@/libs/common/utils';
import type { MarketOptionPriceHistory, ApiInstance, MarketOptionPriceHistoryParams } from '@/libs/sdk/api';
import { useSSEQuery } from '../hooks/use-sse-query';

export const useOptionsPriceHistory = (
  api: ApiInstance,
  searchParams: MarketOptionPriceHistoryParams,
  options?: CustomUseQueryOptions<MarketOptionPriceHistory>
) => {
  const { queryKey, enabled = true, ...rest } = options || {};

  return useSSEQuery(
    api.sse,
    {
      ...rest,
      enabled: enabled && hasNonEmptyProp(searchParams, ['baseTokenAddress']),
      queryKey: [queryKey, 'OptionsPriceHistory', searchParams],
      queryFn: async () => {
        const { data } = await api.market.getMarketOptionPriceHistory(searchParams!);
        return data;
      },
    },
    [{ event: 'market:price_change', topics: [searchParams.marketAddress] }]
  );
};
